<template>
  <div>
    <CrudList
      title="Families"
      storeName="Families"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"

      sortable
    />
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList}
  };
</script>
